import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getConfig } from "../data/slices/ltiConfig";

export const useLTICheck = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { config } = useSelector((state) => state.ltiConfig);
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!user) return;
    dispatch(getConfig({ ltiVersion: "1.3" }));
  }, [dispatch, user]);

  useEffect(() => {
    // Lock non-owner LTI users out of the general GoMyDesk UI — but NOT
    // when they're on a viewer route (an active LTI launch) or when the
    // launch query flag is set. Otherwise every fresh LTI launch bounces
    // to /session-deleted (a route that doesn't exist → 404).
    if (!(config && user)) return;
    const isOwner = user.roles?.some((role) => role.name === "gomydesk-org-owner");
    if (isOwner || !config?.issuer_url) return;

    const path = location.pathname || "";
    const isViewerRoute =
      path.startsWith("/control/") ||
      path.startsWith("/lti/control/") ||
      path.startsWith("/auth/lti/");
    const isLTILaunch = new URLSearchParams(location.search).get("lti") === "1";
    if (isViewerRoute || isLTILaunch) return;

    navigate("/session-deleted");
  }, [config, user, navigate, location.pathname, location.search]);
};
